import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/UserFooter.css';

const UserFooter = () => {
  return (
    <footer className="user-footer">
      <div className="user-footer-glow"></div>
      <div className="user-footer-container">
        <div className="user-footer-content">
          <img src="/assets/images/logo2.png" alt="LegacyStat" className="user-footer-logo" />
          <div className="user-footer-info">
            <nav className="user-footer-nav">
              <Link to="/privacy" className="user-footer-link">Privacy Policy</Link>
              <Link to="/terms" className="user-footer-link">Terms of Service</Link>
            </nav>
            <p className="user-footer-copyright">© 2026 LEGACYSTAT™. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default UserFooter;
